import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { ParentSize } from '@visx/responsive';
import { useState } from 'react'
import TwitterBlock from '../blocks/TwitterBlock'


export default function PageDrawer() {
  const [open, setOpen] = useState(false);
  const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
        setOpen(open);
      };

  return (
    <>

    <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
      <div style={{height:'100vh', width:'100%'}}>
         <ParentSize>
           {({ width, height }) => (
             <Box className="my_drawer" sx={{ width: 300 }} role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
               <TwitterBlock screenName="TOWER_Shibuya" sourceType="profile" hashtags={['タワ渋イベント', 'タワ渋kpop']} width={width} height={height}  />
              </Box>
           )
           }
         </ParentSize>
      </div>

    </Drawer>

       <button className="open_twitter_drawer" onClick={()=> setOpen(true)}>
          <img src="https://towershibuya.jp/assets/images/svg/x.svg" width="42" height="42" alt="twitter_icon"/>
       </button>
    </>
  );
}
